/**
 * Labstep
 *
 * @module components/Group/Form/ShowEdit/Name
 * @desc Edit Group name
 */

import { fieldName } from 'labstep-web/components/Group/Form/fields';
import { FormShowEditText as ShowEditText } from 'labstep-web/core/Form/ShowEdit/Text';
import type React from 'react';
import type { GroupFormShowEditNameProps } from './types';

export const GroupFormShowEditName: React.FC<
  GroupFormShowEditNameProps
> = ({ group }) => (
  <ShowEditText
    entityName={group.entityName}
    entity={group}
    field={fieldName}
  >
    {group.name}
  </ShowEditText>
);
